import { TReduxActions } from '../../types/redux';
import { ISpecialistCatalogListingSchema } from '../../repositories/demand/entities/specialist_catalog/SpecialistCatalogListingSchema';
import { EActionTypes } from '../../constants/actionTypes/currentRealtor';

export type TCurrentRealtor = ISpecialistCatalogListingSchema | null | undefined;

export const initialState: TCurrentRealtor = null;

export const currentRealtorReducer = (state: TCurrentRealtor = initialState, action: TReduxActions) => {
  switch (action.type) {
    case EActionTypes.Set:
      return action.payload;
    case EActionTypes.Reset:
      return null;
    default:
      return state;
  }
};
